import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./checkout-form.js";
import axios from 'axios';

// Use your React .env variable here
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default function PaymentForm({user, redirect, item, product}) {
  const [clientSecret, setClientSecret] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");

  useEffect(() => {
    axios.post(process.env.REACT_APP_API_URL + 'create-subscription', { 
      priceId: item.id,
      amount: item.amount,
      userData: user
    }).then((r) => {
      if (r?.data?.status == 'Success') {
        setClientSecret(r.data.clientSecret);
        setSubscriptionId(r.data.subscriptionId);
        let userData = JSON.parse(localStorage.getItem('user'));
        userData.subscriptionId = subscriptionId;
        localStorage.setItem('user', JSON.stringify(userData));
      }
    });
  }, []);

  const appearance = {
    theme: 'stripe', // Options: 'stripe', 'night', 'flat', 'none'
    variables: {
      colorPrimary: '#0570de',
      colorBackground: '#ffffff',
      colorText: '#30313d',
      colorDanger: '#df1b41',
      fontFamily: 'Ideal Sans, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px',
    },
    rules: {
      '.Input': {
        border: '1px solid #323232',
      },
      '.Label': {
        fontWeight: '400',
      },
      '.AccordionItem': {
        backgroundColor: '#FCFCFC',
        border: '1px solid #323232',
        marginBottom: '10px',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
      },
      // Targets the row when it is selected/clicked
      '.AccordionItem--selected': {
        borderColor: '#0570de', // Your brand color
        borderWidth: '2px',
        backgroundColor: '#fCfCfC',
      },
      // Targets the text labels inside the accordion
      '.AccordionItemLabel': {
        color: '#323232',
        fontSize: '16px',
      },
      // Targets the radio button icon
      '.AccordionItemCheckbox': {
        color: '#0570de',
      }
    }
  };
  const options = { clientSecret, appearance };

  return (
    <div className="payment-wrapper">
      {clientSecret ? (
        <>
          <div className="item-cost flex f-row gap-10" style={{alignItems: 'baseline'}}>
            <span style={{fontSize: '0.75em'}}>{product}:</span>
            <span className="item-cost flex f-row" style={{alignItems: 'baseline'}}>
              ${(item.amount / 100).toFixed(2)}
              <span style={{fontSize: '0.5em', fontWeight: 400, marginLeft: 5}}>/ {item.interval}</span>
            </span>
          </div>
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm redirect={redirect} />
          </Elements>
        </>
      ) : (
        <div className="w-100 flex f-center mt-40 mb-40">
          <div className="spinner large blue"></div>
        </div>
      )}
    </div>
  );
}